// extracted by mini-css-extract-plugin
export default {"container":"VKNdFbw4NbtshOqCZ7Pg","card":"hlUC92yi9XXMAFOugXVX","close":"H4CTCfYBSJR1mqMhrDWb","logo":"ymXKU481dtGz9fTRA2s3","pulse":"D_yI1qBE4052qjeuXN0a"};